import { Controller } from "stimulus"

// #1263: het afspraakvenster in het rooster. Een klik op een afspraak (link
// met data-turbo-frame="afspraakvenster") laadt het afspraakdetail in de
// Turbo frame in deze <dialog>; dit opent de dialog en toont zolang
// "Laden...". Status, aanwezigheid en de wachtlijst werken binnen het
// venster; is er iets opgeslagen, dan ververst het rooster bij sluiten.
// Sluiten met de knop, Escape of een klik op de achtergrond. Zonder
// JavaScript opent de link gewoon de afspraakpagina.
//
// #1263 (Sam, 20-10-2026): ook Bewerken opent in het venster. Na elke
// geslaagde opslag (formulier, status, aanwezigheid, wachtlijst) laadt het
// rooster achter het venster meteen opnieuw (de frame "rooster_inhoud"),
// terwijl het venster open blijft. Zonder die frame ververst de hele pagina
// bij sluiten, zoals voorheen.
export default class extends Controller {
  static targets = ["dialog", "frame", "laden", "rooster"]

  connect() {
    this.gewijzigd = false
    this.bijVerzenden = (event) => {
      if (!event.detail?.success) return
      if (!this.verversRooster()) this.gewijzigd = true
    }
    this.bijOntbreken = (event) => {
      // Geen venster in het antwoord (afspraak weg, geen toegang): dan de hele pagina
      event.preventDefault()
      this.dialogTarget.close()
      event.detail.visit(event.detail.response)
    }
    this.frameTarget.addEventListener("turbo:submit-end", this.bijVerzenden)
    this.frameTarget.addEventListener("turbo:frame-missing", this.bijOntbreken)
  }

  disconnect() {
    this.frameTarget.removeEventListener("turbo:submit-end", this.bijVerzenden)
    this.frameTarget.removeEventListener("turbo:frame-missing", this.bijOntbreken)
  }

  open(event) {
    // Nieuw tabblad of venster: laat de browser zijn gang gaan
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return

    if (this.hasLadenTarget) this.frameTarget.innerHTML = this.ladenTarget.innerHTML
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  // Laadt alleen het rooster opnieuw; false als dat niet kan
  verversRooster() {
    if (!this.hasRoosterTarget) return false

    const frame = this.roosterTarget
    const adres = window.location.href
    if (frame.getAttribute("src") === adres && typeof frame.reload === "function") {
      frame.reload()
    } else {
      frame.src = adres
    }
    return true
  }

  close(event) {
    event?.preventDefault()
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  achtergrond(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  gesloten() {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.innerHTML = ""
    if (!this.gewijzigd) return

    this.gewijzigd = false
    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: "replace" })
    } else {
      window.location.reload()
    }
  }
}
